import { type PlanDetailsForTracking } from '~/selectors/plans.composite.selectors';
import { type UserPlan } from '~/types/Plan';

export type PlanLevel = 'basic' | 'premier' | 'pro' | 'trial';

/**
 * Returns the plan level (basic, pro, premier) for a given plan display name.
 * @param planName
 */
export const getPlanType = (planName: string): PlanLevel => {
  if (planName.toLowerCase().includes('trial')) return 'trial';

  if (planName.toLowerCase().includes('pro')) return 'pro';

  if (planName.toLowerCase().includes('premier')) return 'premier';

  return 'basic';
};

/**
 * Shapes plan data into an event tracking payload
 * @param rawPlan
 */
export const planToTrackingDetails = (rawPlan: UserPlan): PlanDetailsForTracking => ({
  plan_cost: rawPlan.plan.subscriptionPrice,
  plan_display_name: rawPlan.plan.displayName,
  plan_end_date: rawPlan.endDate?.toISOString() ?? null,
  plan_frequency: rawPlan.plan.billingFrequency,
  plan_label_estimate: rawPlan.plan.numberOfLabelsIncluded,
  plan_level: getPlanType(rawPlan.plan.displayName),
  plan_name: rawPlan.plan.name,
  plan_next_bill_date: null,
  plan_next_end_date: null,
  plan_start_date: rawPlan.startDate.toISOString(),
});
